import { render, staticRenderFns } from "./WebhookDetails.vue?vue&type=template&id=51398dca&"
import script from "./WebhookDetails.vue?vue&type=script&lang=js&"
export * from "./WebhookDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports